// src/environments/environment.dev.ts (DEV backend)

const mobileRedirectUri = 'com.lumivo.postalbridge://auth-redirect';

export const environment = {
  production: true,

  appUrl: 'https://customer-dev.postalbridge.com',

  publicWebBaseUrl: 'https://dev.postalbridge.com',

  msalConfig: {
    auth: {
      clientId: 'cfec9137-0b5b-4483-8ebf-5c3921469140',
      authority:
        'https://postalbridge.b2clogin.com/postalbridge.onmicrosoft.com/B2C_1_PB_SUSI',
      knownAuthorities: ['postalbridge.b2clogin.com'],

      redirectUri: 'https://customer-dev.postalbridge.com/auth-redirect',
      postLogoutRedirectUri: mobileRedirectUri,

      nativeRedirectUri: mobileRedirectUri,
      mobileRedirectUri: mobileRedirectUri,

      tenantName: 'postalbridge'
    },
    cache: {
      cacheLocation: 'localStorage' as const,
      storeAuthStateInCookie: false
    }
  },

  apiConfig: {
    apiUrl: 'https://api-dev.postalbridge.com/api',
    odataUrl: 'https://api-dev.postalbridge.com/odata',
    scopes: [
      'openid',
      'profile',
      'offline_access',
      'https://postalbridge.onmicrosoft.com/81638f83-2dca-4d7a-be3c-bd59e553a1b8/api.readwrite'
    ]
  }
};
